import { clsx } from "clsx";
import capitalize from "lodash/capitalize";

import { Segment } from "Types/Segment";

import { DynamicLoadingTitle } from "../Loading/DynamicLoadingTitle";
import { LoadingTitleSize } from "../Loading/shared";

import styles from "./SegmentDisplay.module.scss";

/**
 *
 * @param segment any segment object
 * @returns a text element representation of a segment
 */
export function SegmentDisplay({ segment, loading = false }: { segment?: Segment; loading?: boolean }): JSX.Element {
    return (
        <span className={clsx("flex-row justify-between align-center", styles.segmentDisplay)}>
            <DynamicLoadingTitle loading={loading} size={LoadingTitleSize.SMALL}>
                <span className={styles.name}>{segment?.name}</span>
            </DynamicLoadingTitle>
            <span className={clsx(styles.type, "flex-row-reverse")}>
                <DynamicLoadingTitle loading={loading} size={LoadingTitleSize.XSMALL}>
                    <span>{capitalize(segment?.type)}</span>
                </DynamicLoadingTitle>
            </span>
        </span>
    );
}
